var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45992 10.0129L0.314873 18.1987C-0.0960121 18.6108 -0.0960121 19.2789 0.314873 19.691C0.725759 20.103 1.39193 20.103 1.80282 19.691L10.6918 10.759C11.1027 10.3469 11.1027 9.67885 10.6918 9.26679L1.79611 0.309048C1.38523 -0.103016 0.719049 -0.103016 0.308165 0.309048C-0.10272 0.721113 -0.10272 1.3892 0.308165 1.80127L8.45992 10.0129Z",
    fill: "#979092"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.6ff0b1b3c48d58566b24fe468be506df.svg";
export { ForwardRef as ReactComponent };